import { defineComponent as _defineComponent } from 'vue'
import { ShowMoneyToggleButton } from '@/modules/common/components/buttons/ShowMoneyToggleButton';
import {
  NavbarFilter,
  HelperViewStatus,
  StatusColors,
  LoaderIndicator
} from '@warrenbrasil/nebraska-web';
import { BackButton } from '@/modules/common/components/buttons/BackButton';
import PerformanceHeader from '@/modules/investments/views/Performance/components/PerformanceHeader/PerformanceHeader.vue';
import PerformanceChart from '@/modules/investments/views/Performance/components/PerformanceChart/PerformanceChart.vue';
import PerformanceHistorical from '@/modules/investments/views/Performance/components/PerformanceHistorical/PerformanceHistorical.vue';
import { computed, onMounted, ref } from 'vue';
import {
  getPerformanceBenchmarks,
  getPerformanceChart,
  getPerformanceHistorical,
  getPerformancePeriods
} from '@/modules/investments/services/performance';
import {
  IFilter,
  IPerformanceBenchmark,
  IPerformanceHistorical,
  IPerformancePeriods,
  IValues
} from '@/modules/investments/types/Performance';
import { StorageKeys } from '@/modules/common/services/local-storage';
import { useRouter } from 'vue-router/composables';


export default /*#__PURE__*/_defineComponent({
  __name: 'Performance',
  setup(__props) {

const isLoading = ref(false);
const hasError = ref(false);

const chart = ref({});
const periods = ref<IPerformancePeriods[]>([]);
const benchmarks = ref<IPerformanceBenchmark[]>([]);
const historical = ref<IPerformanceHistorical>({});

const router = useRouter();

const getDatas = async (params = {}) => {
  isLoading.value = true;
  hasError.value = false;

  try {
    const [chartData, periodsData, benchmarksData, historicalData] =
      await Promise.all([
        getPerformanceChart(params),
        getPerformancePeriods(params),
        getPerformanceBenchmarks(params),
        getPerformanceHistorical(params)
      ]);

    chart.value = chartData.result;
    periods.value = periodsData.result;
    benchmarks.value = benchmarksData.result;
    historical.value = historicalData.result;
  } catch (error) {
    hasError.value = true;
  }
  isLoading.value = false;
};

onMounted(() => {
  const filters = JSON.parse(
    localStorage.getItem(StorageKeys.SelectedPerformanceFilters) || '{}'
  );
  getDatas(filters);
});

const handleFilterUpdate = async (filters: IFilter[]) => {
  const params = {
    periodType: filters?.[0]?.selected.key,
    benchmarkId: filters?.[1]?.selected.key
  };
  localStorage.setItem(
    StorageKeys.SelectedPerformanceFilters,
    JSON.stringify(params)
  );
  getDatas(params);
};

const selectedPeriod = computed(() =>
  periods.value.find(period => period.active)
);

const selectedBenchmark = computed(() =>
  benchmarks.value.find(benchmark => benchmark.active)
);

const headers = computed(() => [
  {
    description: 'Rendimento bruto',
    value: selectedPeriod.value?.values?.profitValues?.formatted
  },
  {
    description: 'Rentabilidade bruta',
    value: selectedPeriod.value?.values?.returns?.formatted
  },
  {
    description: selectedBenchmark.value?.label,
    value: selectedPeriod.value?.values?.benchmark?.formatted
  },
  {
    description: selectedBenchmark.value?.benchmarkComparisonLabel,
    value: selectedPeriod.value?.values?.benchmarkComparison?.formatted,
    statusValue: !selectedPeriod.value?.values?.benchmarkComparison?.isNegative
      ? StatusColors.POSITIVE
      : StatusColors.NEGATIVE
  }
]);

const filters = computed(() => {
  return [
    {
      key: '1',
      title: 'Período',
      selected: {
        key: selectedPeriod.value?.value,
        title: selectedPeriod.value?.label,
        descriptionFirstValue:
          selectedPeriod.value?.values?.benchmarkComparison?.formatted,
        descriptionSecondValue:
          selectedPeriod.value?.values?.profitValues?.formatted,
        statusDescriptionSecondValue: !selectedPeriod.values
          ?.benchmarkComparison?.isNegative
          ? StatusColors.POSITIVE
          : StatusColors.NEGATIVE
      },
      options: periods.value.map(period => ({
        key: period.value,
        title: period.label,
        descriptionFirstValue: getBenchmarkComparisonFilter(period),
        descriptionSecondValue: period.values?.profitValues?.formatted,
        statusDescriptionSecondValue: !period.values?.benchmarkComparison
          ?.isNegative
          ? StatusColors.POSITIVE
          : StatusColors.NEGATIVE
      }))
    },
    {
      key: '2',
      title: 'Comparar com',
      selected: {
        key: selectedBenchmark.value?.value,
        title: selectedBenchmark.value?.label
      },
      options: benchmarks.value.map(benchmark => ({
        key: benchmark.value,
        title: benchmark.label
      }))
    }
  ];
});

const getBenchmarkComparisonFilter = (value: IValues) => {
  if (!selectedBenchmark.value?.benchmarkComparisonLabel) return '';
  return selectedBenchmark.value?.label === 'CDI'
    ? `${value.values?.benchmarkComparison?.formatted} do CDI`
    : `${selectedBenchmark.value?.benchmarkComparisonLabel} ${value.values?.benchmarkComparison?.formatted}`;
};

function handleBackClick() {
  if (window.history.length > 1) {
    window.history.back();
  } else {
    router.push({ name: 'home' });
  }
}

return { __sfc: true,isLoading, hasError, chart, periods, benchmarks, historical, router, getDatas, handleFilterUpdate, selectedPeriod, selectedBenchmark, headers, filters, getBenchmarkComparisonFilter, handleBackClick, ShowMoneyToggleButton, NavbarFilter, HelperViewStatus, LoaderIndicator, BackButton, PerformanceHeader, PerformanceChart, PerformanceHistorical }
}

})